import React, { useEffect, useState } from "react";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import VerifiedIcon from "@mui/icons-material/Verified";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import ctscan from "../../assets/icons/ct-scan.png";
import backbone from "../../assets/icons/backbone.png";
import xray from "../../assets/icons/x-ray.png";
import mammography from "../../assets/icons/mammogram.png";
import pet_ct from "../../assets/icons/pet_ct-01.png";
import highMri from "../../assets/icons/mri-high.png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import nuclear from "../../assets/icons/nuclear.png";
import cardiogram from "../../assets/icons/cardiogram.png";
import CloseIcon from "@mui/icons-material/Close";
import ultrasound from "../../assets/icons/technology.png";
import { motion } from "framer-motion";
import Faqs from "../Faqs";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
const PatientForms = () => {
  const [examId, setExamId] = useState(null);
  const [openBox, setOpenBox] = useState(false);
  const OpenFullBox = (id) => {
    setOpenBox(!openBox);
    setExamId(id);
  };
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  const faqs = [
    {
      question: "How do I get the results of my examination?",
      answer:
        "Your referring physician will have a report from our radiologist usually within 24-48 hours of the completion of your scan unless requested sooner by your physician.",
    },
    {
      question: "How do I get a copy of my films? ",
      answer:
        "We send your films or CDs to your physician, who can provide them to you upon request. If you need an additional copy, please contact us for more information.",
    },
    {
      question: " How long are my records kept on file?",
      answer:
        "We maintain the films and reports from your exams in accordance with state laws.",
    },
  ];
  return (
    <div className="pt-16 sm:pt-20 md:pt-24 lg:pt-[12.0625rem] text-white flex justify-center items-center flex-col relative ">
      <div className="px-4 pb-8 pt-16 sm:px-6 sm:pt-10 md:px-8 md:pt-12 lg:px-10 flex 2xl:w-3/4 xl:w-4/5 w-11/12  slider-wrapper overflow-hidden justify-center relative items-center flex-col lg:pt-16">
        <div className="text-center my-8 xl:mt-16 ">
          <h1
            data-aos="fade-up"
            className="text-white font-Antique text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[9.25rem] lg:mb-32 md:mb-24 lowercase tracking-[-.04em] leading-tight"
          >
            for patients
          </h1>
          <div className="md:text-3xl text-2xl md:leading-10 tracking-tight text-white pt-6   lg:pt-12 xl:pt-[4.75rem] font-Matter"></div>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="100"
          className="text-left md:w-11/12 w-full"
        >
          <h2 className="text-[#cfa751] sm:text-4xl font-Antique text-2xl lg:mb-0 mb-4 font-light">
            Book An Appointment
          </h2>
          <p className="font-Matter md:text-2xl text-xl font-medium text-white md:px-4 md:pt-6 pt-2">
            To book and schedule your appointment, give us a call at
            352-795-9200 at our office from Monday to Friday during working
            hours (8:30 am - 5 pm).
          </p>
          <p className="font-Matter md:text-2xl text-xl font-medium text-white md:px-4 py-2">
            Before you schedule an appointment, don’t forget to:
          </p>
          <ul className="pt-3 md:ps-16">
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                Inform beforehand regarding cancellation or rescheduling.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                Inform our staff about your medical conditions.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                Keep us updated about any allergies or medical complications.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <PlaylistAddCheckCircleIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                Inform about your past examinations and share a copy of it.
              </span>
            </li>
          </ul>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="200"
          className="text-left md:w-11/12 w-full my-12"
          id="forms"
        >
          <h2 className="text-[#cfa751] sm:text-4xl font-Antique text-2xl lg:mb-0 mb-4 font-light">
            Patient Registration Forms
          </h2>
          <p className="font-Matter md:text-2xl text-xl font-medium text-white md:px-4 md:pt-6 pt-2">
            Streamline your check-in process effortlessly by completing the
            following patient forms and bringing the printout of them on your
            scheduled visit.
          </p>
          <div className="grid xl:grid-cols-3 md:grid-cols-2 gap-3 pt-4 sm:p-4">
            <div className="flex justify-center items-center p-2">
              <a
                href="./newpatientform.pdf"
                download="New_Patient_Form.pdf"
                className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <EditCalendarIcon /> New Patient Form
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
              </a>
            </div>
            <div className="flex justify-center items-center p-2">
              {/* <button
                onClick={() => window.open("./mripatientform.pdf", "_blank")}
                className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#a374ff] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>

                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center ps-3 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <EditCalendarIcon /> MRI Patient Form
                  </span>
                  <span className="absolute flex flec-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
              </button> */}
              <a
                href="./mripatientform.pdf"
                download="mripatientform.pdf"
                className="nav-cta button button-outlined"
                data-button-svg=""
              >
                <span className="button-inner ">
                  <span className="button-inner-static ">
                    <EditCalendarIcon /> MRI Patient Form
                  </span>
                  <span className="button-inner-hover ">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
                <span>
                  <svg
                    className="button-outlined-bg"
                    enableBackground="new 0 0 153.81333333333333 56"
                    viewBox="0 0 153.81333333333333 56"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <clipPath id="buttonSvg_U5NPDA2Q2">
                      <path
                        className="button-stroke "
                        d="m125.81333333333333 1c14.9 0 27 12.1 27 27s-12.1 27-27 27h-97.81333333333333c-14.9 0-27-12.1-27-27s12.1-27 27-27zm0-1h-97.81333333333333c-15.5 0-28 12.5-28 28 0 15.5 12.5 28 28 28h97.81333333333333c15.5 0 28-12.5 28-28 0-15.5-12.5-28-28-28z"
                      />
                    </clipPath>
                    <g clipPath="url(#buttonSvg_U5NPDA2Q2)">
                      <g className="button-circles">
                        <g className="button-circles-o">
                          <circle
                            pathLength="1"
                            className="button-circle -layer-1"
                            strokeWidth="153.81333333333333"
                            cx="76.90666666666667"
                            cy="28"
                            r="76.90666666666667"
                          />
                          <circle
                            pathLength="1"
                            className="button-circle -layer-2"
                            strokeWidth="153.81333333333333"
                            cx="76.90666666666667"
                            cy="28"
                            r="76.90666666666667"
                          />
                          <circle
                            pathLength="1"
                            className="button-circle -layer-3"
                            strokeWidth="153.81333333333333"
                            cx="76.90666666666667"
                            cy="28"
                            r="76.90666666666667"
                          />
                          <circle
                            pathLength="1"
                            className="button-circle -layer-4"
                            strokeWidth="153.81333333333333"
                            cx="76.90666666666667"
                            cy="28"
                            r="76.90666666666667"
                          />
                        </g>
                        <circle
                          pathLength="1"
                          className="button-circle -hover"
                          strokeWidth="153.81333333333333"
                          cx="76.90666666666667"
                          cy="28"
                          r="76.90666666666667"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </a>
            </div>
            <div className="flex justify-center items-center p-2">
              <a
                href="./privacypatientform.pdf"
                download="privacy patientform.pdf"
                className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
              >
                <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                  <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                    <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  </span>
                </span>
                <span className="relative">
                  <span className="flex flex-row gap-2 justify-center items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <EditCalendarIcon /> Privacy Patient Form
                  </span>
                  <span className="absolute flex flex-row gap-2 top-0 left-10 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                    <CloudDownloadIcon /> Download
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="300"
          className="text-left md:w-11/12 w-full mb-12"
          id="insurance"
        >
          <h2 className="text-[#cfa751] sm:text-4xl font-Antique text-2xl lg:mb-0 mb-4 font-light">
            Billing & Medical Coverages
          </h2>

          <ul className="pt-3 md:ps-16">
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <VerifiedIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                You can pay the bill by cash, check or credit card.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <VerifiedIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                We have a secure portal for bill payments and inquiries.
              </span>
            </li>
            <li className="flex flex-row items-center my-3 sm:gap-4 gap-2">
              <span className="text-[#cfa751] font-Matter text-3xl font-medium">
                <VerifiedIcon fontSize="30px" />
              </span>{" "}
              <span className="md:text-xl text-lg">
                We accept many medical insurance plans, like (names of the
                insurances).
              </span>
            </li>
          </ul>
        </div>
        <div className="text-left md:w-11/12 w-full my-12" id="exam-prep">
          <h2
            data-aos="fade-up"
            data-aso-delay="200"
            className="text-[#cfa751] sm:text-4xl font-Antique text-2xl lg:mb-0 mb-4 font-light"
          >
            Pre-Exam Preparation
          </h2>
          <p
            data-aos="fade-up"
            data-aso-delay="200"
            className="font-Matter md:text-2xl text-xl font-medium text-white md:px-4 md:pt-6 pt-2"
          >
            Get prepared effectively before attending any diagnostic exams.
            Follow the instructions based on each of the following diagnostic
            tests:
          </p>
          <ul className="pt-3  mt-16">
            <li
              data-aos="fade-up"
              data-aso-delay="100"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none "
            >
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#cfa751]"></div>
                <span className="text-[#a374ff] font-Matter text-3xl font-medium">
                  <img src={ctscan} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 my-4 md:px-3 xl:px-0 font-light">
                  Computed Tomography Scan (CT Scan)
                </span>
                <button
                  onClick={() => OpenFullBox(1)}
                  className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8  font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none"
            >
              <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#a374ff]"></div>
                <span className="text-[#a374ff] font-Matter text-3xl font-medium"></span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 mb-4 font-light"></span>
              </div>
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <span className="text-[#a374ff] font-Matter text-3xl font-medium">
                  <img src={backbone} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center capitalize  font-Antique text-2xl lg:mb-0 my-4 font-light">
                  Bone Densitometry / DEXA Scan / DEXA Bone Imaging
                </span>
                <button
                  onClick={() => OpenFullBox(2)}
                  className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>
                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none "
            >
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#17f1d1]"></div>
                <span className="text-[#a374ff] font-Matter text-3xl font-medium">
                  <img src={mammography} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 my-4 font-light">
                  Digital Mammography
                </span>
                <button
                  onClick={() => OpenFullBox(3)}
                  className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8  font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none"
            >
              <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#ff3fdf]"></div>
                <span className="text-[#a374ff] font-Matter text-3xl font-medium"></span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 mb-4 font-light"></span>
              </div>
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <span className="text-[#ff3fdf] font-Matter text-3xl font-medium">
                  <img src={xray} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center capitalize  font-Antique text-2xl lg:mb-0 mb-4 font-light">
                  Digital X-Ray
                </span>
                <button
                  onClick={() => OpenFullBox(4)}
                  className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>
                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none "
            >
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#fd6b6b]"></div>
                <span className="text-[#ffffff] font-Matter text-3xl font-medium">
                  <img src={cardiogram} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 my-4 font-light">
                  Echocardiography
                </span>
                <button
                  onClick={() => OpenFullBox(5)}
                  className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8  font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none"
            >
              <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#fc6d1a]"></div>
                <span className="text-[#fc6d1a] font-Matter text-3xl font-medium"></span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 mb-4 font-light"></span>
              </div>
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <span className="text-[#a374ff] font-Matter text-3xl font-medium">
                  <img src={nuclear} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center capitalize  font-Antique text-2xl mt-3  mb-2 font-light">
                  Nuclear Medicine
                </span>
                <button
                  onClick={() => OpenFullBox(6)}
                  className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>
                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none "
            >
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#a7ff6c]"></div>
                <span className="text-[#a374ff] font-Matter text-3xl font-medium">
                  <img src={highMri} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 my-4 font-light">
                  Open and High-Feild 1.5T MRI
                </span>
                <button
                  onClick={() => OpenFullBox(7)}
                  className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8  font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none"
            >
              <div className="flex flex-col h-full justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] absolute right-[5px] md:block hidden top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 w-3 h-3 md:block hidden rounded-full bg-[#FFC1CC]"></div>
                <span className="text-[#a374ff] font-Matter text-3xl font-medium"></span>{" "}
                <span className="text-[#cfa751] text-center  font-Antique text-2xl lg:mb-0 mb-4 font-light"></span>
              </div>
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <span className="text-[#a374ff] font-Matter text-3xl font-medium">
                  <img src={pet_ct} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#cfa751] text-center capitalize  font-Antique text-2xl  my-2 font-light">
                  PET/CT Scan
                </span>
                <button
                  onClick={() => OpenFullBox(8)}
                  className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>
                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
            <li
              data-aos="fade-up"
              data-aso-delay="200"
              className="grid md:grid-cols-2 grid-cols-1 items-center my-3 md:pb-0 pb-6 border-b-[1px] border-[#fafaf6a4] md:border-none "
            >
              <div className="flex flex-col justify-center items-center  relative overflow-hidden">
                <div className="w-[1px] h-[100%] md:block hidden absolute right-[5px] top-[1.2rem] bg-[#fafaf6a4]"></div>
                <div className="absolute right-0 top-0 md:block hidden w-3 h-3 rounded-full bg-[#DAA520]"></div>
                <span className="text-[#004D61] font-Matter text-3xl font-medium">
                  <img src={ultrasound} className="w-32" alt="" />
                </span>{" "}
                <span className="text-[#DAA520] text-center  font-Antique text-2xl lg:mb-0 my-4 font-light">
                  UltraSound
                </span>
                <button
                  onClick={() => OpenFullBox(9)}
                  className="group relative inline-flex h-14 mt-6 w-[256px] items-center rounded-full px-8  font-semibold text-white bg-transparent overflow-hidden"
                >
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-6 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> More Details
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-12 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Open
                    </span>
                  </span>
                </button>
              </div>
            </li>
          </ul>
        </div>
        <div data-aos="fade-up" data-aso-delay="200" id="records">
          <Faqs faqs={faqs} />
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="300"
          className="text-left md:w-11/12 w-full my-16"
          id="patient-rosource"
        >
          <h2 className="text-[#cfa751] sm:text-4xl font-Antique text-2xl lg:mb-0 mb-4 font-light">
            Healthcare Resources
          </h2>
          <p className="font-Matter md:text-2xl text-xl font-medium text-white md:px-4 md:pt-6 pt-2">
            For more details regarding the medical conditions you or any of your
            known ones are dealing with, you can refer found from the resources
            below:
          </p>
          <div className="grid  md:grid-cols-2 gap-3 pt-4 sm:p-4">
            <div className="flex justify-center items-center p-2">
              <a
                href="https://www.radiologyinfo.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <button className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden">
                  <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-0 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <EditCalendarIcon /> RADIOLOGYINFO.ORG
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Visit
                    </span>
                  </span>
                </button>
              </a>
            </div>
            <div className="flex justify-center items-center p-2">
              <a
                href="https://www.acr.org/clinical-resources/practice-management/toolkit/patient-resources"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden">
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>
                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-10 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <EditCalendarIcon />
                      ACR.ORG
                    </span>
                    <span className="absolute flex flex-row gap-2 top-0 left-14 opacity-0 w-full h-full translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Visit
                    </span>
                  </span>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aso-delay="400"
          className="text-left md:w-11/12 w-full my-16"
          id="pss"
        >
          <h2 className="text-[#cfa751] sm:text-4xl font-Antique text-2xl lg:mb-0 mb-4 font-light">
            Patient Feedback Form
          </h2>
          <p className="font-Matter md:text-2xl text-xl font-medium text-white md:px-4 md:pt-6 pt-2">
            Please fill out the following feedback form, which will help us
            gather the information and improve our services to provide our
            patients with more effective treatment and provide them the best
            care possible:
          </p>
          <div className="grid  md:grid-cols-2 gap-3 pt-4 sm:p-4">
            <div className="flex justify-center items-center p-2">
              <a
                href="https://www.emailmeform.com/builder/form/bFA4tI8783"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <button className="group relative inline-flex h-14 mt-3 w-[256px] items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden">
                  <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                    <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                      <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                      <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                    </span>
                  </span>

                  <span className="relative">
                    <span className="flex flex-row gap-2 justify-center ps-2 items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <EditCalendarIcon /> Click here to begin
                    </span>
                    <span className="absolute flex flec-row gap-2 top-0 left-14 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                      <OpenInNewIcon /> Visit
                    </span>
                  </span>
                </button>
              </a>
            </div>
            <div className="flex justify-center items-center p-2"></div>
          </div>
        </div>
      </div>
      <motion.div
        initial={{
          height: 0,
          clipPath: "ellipse(100% 55% at 48% 44%)",
        }}
        animate={{
          height: openBox ? "100vh" : 0,
          clipPath: openBox
            ? [
                "ellipse(100% 55% at 48% 44%)",
                "ellipse(100% 80% at 50% 50%)",
                "inset(0% 0% 0% 0%)",
              ]
            : [
                "inset(0% 0% 0% 0%)",
                "ellipse(100% 80% at 50% 50%)",
                "ellipse(100% 55% at 48% 44%)",
              ],
        }}
        transition={{
          height: {
            type: "spring",
            stiffness: 200,
            damping: 30,
          },
          clipPath: {
            duration: 1.5,
            ease: "easeInOut",
          },
        }}
        className="w-full bg-[#fafaf6] fixed top-0 z-50 overflow-x-auto xl:overflow-hidden"
      >
        <div
          className={`w-full h-full flex justify-center ${
            examId === 6 ? "pt-12" : "md:pt-40"
          } pt-28 relative`}
        >
          <div className="absolute md:top-10 top-4 right-8">
            <button
              onClick={() => setOpenBox(!openBox)}
              className="group relative inline-flex h-16 mt-3 w-16 items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden"
            >
              <span className="absolute inset-0 rounded-full bg-[#a374ff] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                  <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                </span>
              </span>

              <span className="relative">
                <span className="flex  -ml-4  items-center  text-4xl justify-center  group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <CloseIcon fontSize="30px" />
                </span>
                <span className="absolute flex items-center  text-4xl justify-center gap-2 -top-1 -left-4 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  <CloseIcon fontSize="30px" />
                </span>
              </span>
            </button>
          </div>
          {examId === 1 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                Computed Tomography Scan
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  1. For Brain, Posterior Fossa/IACs, Neck (soft tissue), Chest,
                  Abdomen, Pelvis, Urogram.
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  Nothing to eat or drink except water 4 hours before the test.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  2. For Sinuses, C-Spine, T-Spine, L-Spine.
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  No special instructions.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  3. For all types of CT ANGIOGRAPHY.
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  Nothing to eat or drink except water 4 hours before the test.
                </p>
              </div>
            </div>
          ) : null}
          {examId === 2 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                Bone Densitometry/DEXA Scan/DEXA Bone Imaging
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  No special instructions
                </h4>
              </div>
            </div>
          ) : null}
          {examId === 3 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                Digital Mammography
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  1. For convenience, wear a two-piece outfit.
                </h4>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  2. If possible, bring previous mammography reports.
                </h4>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  3. Do not use deodorant, perfume or powder below the arms and
                  breast area.
                </h4>
              </div>
            </div>
          ) : null}
          {examId === 4 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                Digital X-Ray
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  No special instructions
                </h4>
              </div>
            </div>
          ) : null}{" "}
          {examId === 5 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                Echocardiography
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  No special instructions
                </h4>
              </div>
            </div>
          ) : null}
          {examId === 6 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                Nuclear Medicine
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  1. For Bone Scans, Renal Scan, Renal Scan w/Lasix
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  No special instructions.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  2. For Renal Scan with Captopril
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  Nothing to eat or drink for 4 hours before the test
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  3. For Thyroid Scan & Uptake
                </h4>
                <p className="ps-8 text-[#1d1d1f] pb-2 text-xl font-Matter ">
                  No lithium for the past 48 hours
                </p>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  No thyroid medication, iodine contrast, or shellfish for the
                  past 3 weeks.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  4. For Gastric or G.B. (Hepatobiliary) Scans
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl font-Matter ">
                  Nothing to eat or drink after midnight.
                </p>
              </div>{" "}
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  5. Myocardial (Heart) Scan with Stress Test / Nuclear Medicine
                  Heart Perfusion Stress Test
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Wear comfortable clothing.
                </p>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  No food, liquids, or medications 3 hours prior to exam.
                </p>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Bring all medications to Citrus Diagnostic Center on
                  examination day.
                </p>
                <p className="ps-8 text-[#1d1d1f]  text-xl pb-2 font-Matter ">
                  NO CAFFEINE OR CHOCOLATE PRODUCTS 48 HOURS PRIOR TO EXAM.
                </p>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Ask the Doctor before taking any heart medications that are
                  beta blockers or calcium channel blockers 48 hours the study
                </p>
              </div>
            </div>
          ) : null}
          {examId === 7 ? (
            <div className="md:w-3/5  w-11/12 text-left overflow-y-auto">
              <h3 className="text-[#1d1d1f] font-Antique text-2xl lg:text-3xl lg:mb-0  font-light">
                Open and High-Feild 1.5T MRI
              </h3>
              <div className="p-2">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  1. For the MRI test & MR Angiography
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Wear comfortable clothing.
                </p>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Wear no metal or eye makeup.
                </p>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  <strong>Note:</strong> Patients with a pacemaker or aneurysm
                  clip surgery in the brain cannot have an MRI.
                </p>
              </div>
            </div>
          ) : null}
          {examId === 8 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                PET/CT Scan
              </h3>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  Nothing to eat or drink except water for 6 hours before the
                  test
                </h4>
              </div>
            </div>
          ) : null}
          {examId === 9 ? (
            <div className="md:w-3/5  w-11/12 text-left">
              <h3 className="text-[#1d1d1f]  font-Antique text-2xl lg:text-3xl lg:mb-0 my-4 font-light">
                UltraSound
              </h3>

              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  1. Abdominal (Complete Survey) or Gallbladder Sonogram
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Nothing to eat or drink 4 hours before the test.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  2. Thyroid, Kidney, or Aorta Sonogram, Aorta Sonogram w/
                  Doppler
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  No special instructions.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  3. Abdominal (Complete Survey) or Gallbladder Sonogram
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  No special instructions.
                </p>
              </div>
              <div className="p-4">
                <h4 className="text-[#1d1d1f] font-kumbh text-xl md:text-2xl font-medium my-2">
                  4. Vascular Doppler Studies
                </h4>
                <p className="ps-8 text-[#1d1d1f] text-xl pb-2 font-Matter ">
                  Drink 32oz. of water 1 hour before the exam.
                </p>
              </div>
            </div>
          ) : null}
        </div>
      </motion.div>
    </div>
  );
};

export default PatientForms;
